angular.module('impactx.cscontract').controller('CSContractLimitViewCtrl', CSContractLimitViewCtrl);
CSContractLimitViewCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ToolbarService'
];

function CSContractLimitViewCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ToolbarService) {
    $scope.view = function () {
        dataGen.getData($scope, {id: $routeParams.id}, "/cscontract/limit/view").then(function () {
            defineButtons();
        });
    };

    $scope.view();

    $scope.selectContract = function () {
        var cscId = $scope.data.cscId;
        dataGen.getData($scope, {id: cscId}, "/cscontract/limit/view", function () {
        });
    };

    $scope.addEntry = function () {
        $scope.data.entrys.push({
            productCategory: '',
            orderCompany: 0,
            limitValue: {value: 0.00},
            currency: $scope.data.currency,
            limitType: 'MAX'
        });
    };

    $scope.removeEntry = function (index) {
        $scope.data.entrys.splice(index, 1)
    };

    $scope.save = function () {
        return dataGen.postAsForm($scope, {data: $scope.data}, "/cscontract/limit/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return $scope.data.cscId > 0;
    }
}
